// Who can open the Pre-Bid Calculator besides admins.
// Add a person by their CPR Live username, or their first name as it appears on the Staff list
// (lower-case). Example: ['rob', 'maria']
export const PREBID_PEOPLE = ['rob'];

export function canUsePrebid(auth) {
  if (!auth) return false;
  if (auth.isAdmin) return true;
  const user = String(auth.username || '').trim().toLowerCase();
  const first = String(auth.staff_name || '').trim().split(/\s+/)[0]?.toLowerCase() || '';
  return PREBID_PEOPLE.some(p => p === user || p === first);
}
